import * as React from 'react';
import Styled, { css } from 'styled-components';

import { media } from '../../lib/StyledComponents';
import SVGIcon, { ISVGIconProps, VALID_ICONS } from '../Icon/SVGIcon';

const Close = Styled.div`
  position: absolute;
  top: 0;
  right: 0;
  z-index: 999;

  a {
    padding: ${({ theme: { modal } }) => modal.closePadding};
    display: block;
  }
`;

const TakeOverIcon = Styled(SVGIcon)<ISVGIconProps>`
  color: ${props => props.theme.colorSlate50};
  width: 32px;
  height: 32px;

  svg {
    fill: currentColor;
  }

  ${props => css`
    ${media.small`
      color:  ${props.theme.colorSlate50};

      &:hover {
        color:  ${props.theme.colorSlate70};
      }
    `}
  `}
`;

const ModalIcon = Styled(SVGIcon)<ISVGIconProps>`
  display: flex;
  align-items: center;
  color: ${({ theme: { modal } }) => modal.colorClose};
  width: ${({ theme: { modal } }) => modal.mobileCloseSize ? modal.mobileCloseSize : '1.6875em'};
  height: ${({ theme: { modal } }) => modal.mobileCloseSize ? modal.mobileCloseSize : '1.6875em'};

  ${({ theme: { modal } }) => css`
    ${media.small`
      width: ${modal.closeSize};
      height: ${modal.closeSize};
    `}
  `}

  svg {
    fill: currentColor;
    width: 100%;
  }
`;

export interface IModalCloseProps extends React.HTMLAttributes<HTMLDivElement> {
  close: React.FormEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  icon?: VALID_ICONS;
  takeOver?: boolean;
}

export class ModalClose extends React.Component<IModalCloseProps> {
  public render () {
    const { takeOver, close, icon, ...rest } = this.props;

    return (
      <Close {...rest}>
        {/* tslint:disable react-a11y-anchors */}
        <a onClick={this.closeHandler} aria-label='Close' role='button' href='#'>
          {takeOver ? <TakeOverIcon icon='workflow-close' /> : <ModalIcon icon={this.props.icon || 'alert-close'} />}
        </a>
      </Close>
    );
  }

  private readonly closeHandler: React.FormEventHandler<HTMLAnchorElement | HTMLButtonElement> = e => {
    e.preventDefault();
    this.props.close(e);
  }
}
